import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';
import { SpacingProps } from '@sdk/components/ui/spacing/Spacing';

export const PaymentDetailsContainer = styled(Column)<{ autoWidth?: boolean } & SpacingProps>`
  width: ${({ autoWidth }) => (autoWidth ? 'auto' : '730px')};
`;

export const PaymentDetailsForm = styled(Column)<{ autoWidth?: boolean }>`
  width: ${({ autoWidth }) => (autoWidth ? 'auto' : '485px')};
`;
